import type { AppContextType } from "lib/apollo/types"

import React from "react"
import { AppContext } from "utils/app-context"

export const useAppContext = (): AppContextType => {
  return React.useContext(AppContext)
}
